var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "boss-message-box",
      class: { "boss-message-box-can-send": _vm.canSendMessage },
    },
    [
      _c("img", {
        staticClass: "boss-message-box-avatar",
        attrs: { src: require("@/assets/images/avatar-company.svg") },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "boss-layout-block" },
        [
          _c("div", { staticClass: "boss-message-reservation-header-layout" }, [
            _c(
              "div",
              {
                staticClass:
                  "boss-layout-block boss-message-when boss-message-when-reservation",
                attrs: { "data-test": "reservation-date" },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.reservationStatusLabel) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.canSendMessage
              ? _c(
                  "div",
                  {
                    staticClass:
                      "boss-layout-block boss-message-reservation-delete-button",
                    attrs: { "data-test": "button-delete" },
                    on: {
                      click: function ($event) {
                        return _vm.doRemove()
                      },
                    },
                  },
                  [
                    _c("span", {
                      staticClass:
                        "boss-icon-trash pega-input-button vertical-alien-middle",
                    }),
                    _vm._v("メッセージを削除する\n      "),
                  ]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("entry-message-subject", {
            attrs: { subject: _vm.messageReservation.message.subject },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              class: { "is-open": _vm.isOpen },
              attrs: { "data-test": "accordion" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "boss-mini-accordion-body-grid margin-bottom-0",
                },
                [
                  _c(
                    "div",
                    { staticClass: "boss-mini-accordion-body-grid-content" },
                    [
                      _c("entry-message-body", {
                        attrs: { body: _vm.messageReservation.message.body },
                      }),
                      _vm._v(" "),
                      _vm.messageReservation.interviewAdjustment
                        ? _c("entry-message-history-interview-adjustment", {
                            attrs: {
                              "candidate-dates":
                                _vm.messageReservation.interviewAdjustment
                                  .candidateDates,
                              place: _vm.placeName,
                              "google-map-place": _vm.googleMapPlace,
                              duration:
                                _vm.messageReservation.interviewAdjustment
                                  .duration,
                              "content-names": _vm.contentNames,
                              remarks:
                                _vm.messageReservation.interviewAdjustment
                                  .remarks,
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.messageReservation.files.length
                        ? _c(
                            "div",
                            {
                              staticClass: "boss-layout-block",
                              attrs: { "data-test": "file-content" },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "\n              添付ファイル\n            "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.messageReservation.files,
                                function (file, i) {
                                  return [
                                    _vm.isFileExpired(file)
                                      ? _c(
                                          "div",
                                          {
                                            key: i,
                                            staticClass:
                                              "position-relative pega-break",
                                            attrs: { "data-test": "file-" + i },
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(file.name) +
                                                  " 閲覧期限終了"
                                              ),
                                            ]),
                                          ]
                                        )
                                      : _c("div", { key: "download-" + i }, [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "position-relative pega-break boss-message-reservation-download-button",
                                              attrs: {
                                                "data-test": "file-" + i,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.download(
                                                    file.id,
                                                    file.name
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatFile")(file)
                                                  )
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ]),
                                  ]
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formatSelection
                        ? _c("div", { attrs: { "data-test": "selection" } }, [
                            _vm._v(
                              "\n            ※送信後に" +
                                _vm._s(_vm.formatSelection) +
                                "に更新します。\n          "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.useAccordion
                ? _c(
                    "div",
                    {
                      staticClass:
                        "boss-mini-accordion-head custom margin-top-1",
                      attrs: { "data-test": "accordion-title" },
                      on: { click: _vm.toggle },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.accordionTitle) + "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.canSendMessage
        ? _c("div", { staticClass: "boss-message-last-button-block" }, [
            _c(
              "button",
              {
                staticClass: "boss-button pega-button",
                attrs: {
                  type: "button",
                  "data-test": "edit-message",
                  disabled: _vm.isWithdraw,
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("setMessage")
                  },
                },
              },
              [_vm._v("\n      予約メッセージを編集する\n    ")]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }